import { useMutation } from '@apollo/client';
import Box from '@material-ui/core/Box';
import HealthCareFacilityForm from 'master-list/common/Form';
import { CreateCareFacilityMutation } from 'master-list/common/Schema';
import { setTelecomAndPractitionerCareFacility } from 'master-list/common/utils';
import {
  DEFAULT_TYPE_HOME_HEALTH,
  HOME_HEALTH_ATTRIBUTES,
} from 'master-list/constants';
import { ICareFacility } from 'master-list/home-health';
import React, { useCallback, useState } from 'react';
import AsynchronousLayout from 'styleguide/layout/Asynchronous';
import FormLayout from 'styleguide/layout/Form';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};
const CreateFacility: React.FC<Props> = ({ isOpen, onClose }) => {
  const [formValid, setFormValid] = useState<boolean>(false);

  const [formData, setFormData] = useState<ICareFacility>({
    organization: {
      resourceType: 'Organization',
      active: true,
      type: [DEFAULT_TYPE_HOME_HEALTH],
    },
  });

  const [submit, { loading, error }] = useMutation(CreateCareFacilityMutation, {
    refetchQueries: ['getHealthCareFacilityList'],
    awaitRefetchQueries: true,
  });

  const handleSubmit = useCallback(async () => {
    try {
      await submit({
        variables: {
          ...setTelecomAndPractitionerCareFacility(formData),
        },
      });
      onClose();
    } catch {}
  }, [submit, formData, onClose]);

  return (
    <Box display="flex" flexDirection="column" height={1} width={1}>
      <AsynchronousLayout data={formData}>
        <FormLayout
          isValid={
            formValid &&
            formData?.organization?.address &&
            formData?.organization?.address?.[0]?.state
              ? true
              : false
          }
          onSubmit={handleSubmit}
          onCancel={onClose}
          error={error}
          loading={loading}
        >
          <Box pt={1} flexGrow="1" display="flex">
            <Box width={1} height="auto">
              <HealthCareFacilityForm
                data={formData}
                onChange={setFormData}
                onValidate={setFormValid}
                formFields={HOME_HEALTH_ATTRIBUTES}
              />
            </Box>
          </Box>
        </FormLayout>
      </AsynchronousLayout>
    </Box>
  );
};

export default CreateFacility;
